export const BEM_NAME = 'person_record';
export const TABS_CONTENT_BEM_NAME = 'tabs_content';
